import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";

const TIPOS = {
    alerta: { bg: "#E24B4A", color: "#fff" },
    advertencia: { bg: "#ffb74bff", color: "#fff", borderColor: "#412402" },
    comentario: { bg: "#639922", color: "#fff" },
    mensaje: { bg: "#0063BE", color: "#fff" },
};

export default function Comunicado({
    open,
    onClose,
    tipo = "mensaje",
    titulo,
    mensaje = "",
}) {
    const estilo = TIPOS[tipo] ?? TIPOS.mensaje;
    const tituloFinal = titulo || "Notificación";

    return (
        <Dialog
            open={open}
            PaperProps={{
                sx: { borderRadius: 3, minWidth: 280, overflow: "hidden" },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: "center",
                    fontWeight: 500,
                    bgcolor: estilo.bg,
                    color: estilo.color,
                    pb: 1.5,
                }}
            >
                {tituloFinal}
            </DialogTitle>

            <DialogContent sx={{ pt: "16px !important", pb: 2 }}>
                <DialogContentText sx={{ textAlign: "center", color: "text.primary", fontSize: 14 }}>
                    {mensaje}
                </DialogContentText>
            </DialogContent>

            <DialogActions
                sx={{
                    justifyContent: "center",
                    borderTop: "1px solid",
                    borderColor: "divider",
                    p: 0,
                }}
            >
                <Button
                    onClick={onClose}
                    fullWidth
                    sx={{
                        color: "#2196f3",
                        borderRadius: 0,
                        py: 1.2,
                    }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}